













































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Autocomplete,
  Button,
  Input,
  Option,
  Select,
  Tooltip
} from 'element-ui';
import billItemTemplateUpsert from '@/components/modals/billItemTemplateUpsert.vue';

// gql
import fetchBillItemTemplates from '@/graphql/queries/FetchBillItemTemplates.gql';

// types
import {
  TaxTypeEnum,
  BillItemTemplateFields,
  BillItemFields
} from '@/types/graphql/schemaTypes';

interface BillItemTemplateOptions {
  id?: string;
  isNew?: boolean;
  value: string;
  category?: string;
  taxType?: TaxTypeEnum;
}

@Component({
  components: {
    billItemTemplateUpsert,
    'el-autocomplete': Autocomplete,
    'el-button': Button,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select,
    'el-tooltip': Tooltip
  }
})
export default class billItemTemplateAutocomplete extends Vue {
  @Prop({ default: null, type: [String, null as any] }) value!: string | null;
  @Prop({ default: false, type: Boolean }) disabled!: boolean;
  @Prop() billItem!: BillItemFields;

  billItemTemplateOptions: BillItemTemplateOptions[] = [];
  isLoading = false;
  isCreating = false;
  itemTemplateName = null;
  billItemTemplate = {
    taxType: this.billItem.taxType,
    description: this.billItem.description,
    category: this.billItem.category
  };

  $refs!: { autocompleteRef: HTMLFormElement };

  get content(): string {
    return this.value;
  }

  set content(value: string) {
    this.$emit('input', value);
  }

  /**
   * @param queryString: string, search value
   * @param callback: callback function invocked by fetch-suggestions
   * to return the data:[]
   */
  async querySearch(queryString: string, callback) {
    let results = [];

    try {
      const response = await this.$apollo.query({
        query: fetchBillItemTemplates,
        variables: {
          searchString: queryString
        }
      });

      if (response) {
        if (response.data?.billItemTemplates.length) {
          this.billItemTemplateOptions = response.data.billItemTemplates.map(item => {
            return {
              id: item.id,
              value: item.description,
              category: item.category,
              taxType: item.taxType
            };
          });
          results = this.billItemTemplateOptions;
          // if none of the options match the query add the option to crate an item
          if (queryString !== '' && !results.find(item => item.value === queryString)) {
            results = [...results, { value: queryString, isNew: true }];
          }
        } else {
          // create an item
          results = [{ value: queryString, isNew: true }];
        }
      }
    } catch {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.fetch'),
        time: 2000
      });
    }

    callback(results);
  }

  findTemplate(value: string) {
    return this.billItemTemplateOptions.find(bill => bill.value === value);
  }

  openUpsertModal(item: { value: string }) {
    this.itemTemplateName = item.value;
    this.$refs.autocompleteRef.close();
    this.isCreating = true;
  }

  createTemplate(newTemplate: BillItemTemplateFields) {
    this.$emit('updateItem', newTemplate);
  }

  closeModal() {
    this.isCreating = false;
  }
}
